
import { Button } from "@/components/ui/button";
import { MessageSquare } from "lucide-react";

interface CidadeCTAProps {
  cidadeFormatted: string;
}

const CidadeCTA = ({ cidadeFormatted }: CidadeCTAProps) => {
  return (
    <section className="py-16 px-6 md:px-12 bg-gradient-to-r from-seo-primary to-seo-secondary text-white">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl font-bold mb-6">
          Aumente sua visibilidade em {cidadeFormatted} hoje mesmo
        </h2>
        <p className="text-xl mb-8 text-white/90">
          Não deixe sua empresa invisível para os clientes de {cidadeFormatted}. 
          Entre em contato agora e receba uma análise gratuita.
        </p>
        <div className="flex justify-center">
          <Button 
            size="lg" 
            className="bg-green-500 hover:bg-green-600 text-white text-lg px-8 py-6 flex items-center gap-2"
            onClick={() => window.open('https://wa.me/5555115197440?text=Ol%C3%A1%2C%20quero%20uma%20analise%20da%20LocalUP.', '_blank')}
          >
            <MessageSquare className="w-5 h-5" /> Fale conosco no WhatsApp
          </Button>
        </div>
        <p className="mt-6 text-white/80">
          Receba um diagnóstico gratuito do seu negócio em {cidadeFormatted}.
        </p>
      </div>
    </section>
  );
};

export default CidadeCTA;
